module.exports = __webpack_public_path__ + "static/media/wiper-blades.f45036c1.svg";